<svc-button class="button-confirm" [color]="'primary'" [mode]="'flat'" [type]="type" [disabled]="disabled" [disabled]="disabled">
  <span *ngIf="!processing"> {{ label }} </span>
  <mat-progress-spinner *ngIf="processing" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
</svc-button>
